/* テキストエリア */
import React, { memo } from 'react';
import { FormControl, Col, Row } from 'react-bootstrap';
import RowTemplate from '../atoms/RowTemplate';
import Messages from '../molecules/Messages';
import Paragraph from '../molecules/Paragraph';
import { convertLine, calcRow } from '../Convert';

interface Props {
  id: string;
  fm_id?: number;
  label: string;
  need?: boolean;
  value: string;
  placeholder?: string;
  handleChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  help_msg?: string;
  message?: string;
  name: string;
  rows?: number;
  disabled: boolean;
  handleBlur?: VoidFunction;
  maxlength?: number;
  looks_inactive?: boolean;
  readonly?: boolean;
}

const TextArea: React.FC<Props> = ({
  id,
  fm_id,
  label,
  need,
  value,
  placeholder,
  handleChange,
  help_msg,
  message,
  name,
  rows,
  disabled,
  handleBlur,
  maxlength,
  looks_inactive,
  readonly,
}) => {
  /**
   * テキストエリアを描画する
   * @return JSX.Element テキストエリアのElement
   */
  const returnTextFormJsx = () => {
    return (
      <>
        <FormControl
          id={id}
          data-fm_id={fm_id}
          as="textarea"
          rows={rows ? rows : calcRow(value)}
          onChange={handleChange}
          value={value}
          placeholder={placeholder}
          name={name}
          disabled={disabled || readonly}
          onBlur={handleBlur}
          maxLength={maxlength}
          className={message && 'textarea-error'}
        />
        <Messages help_msg={help_msg} valid_msg={message} />
      </>
    );
  };

  /**
   * ラベルを描画する
   * @return JSX.Element ラベルのエレメント
   */
  const returnLabelJsx = () => {
    return (
      <Row>
        <Col>
          <Paragraph css_class="text-area" label={convertLine(value)} />
        </Col>
      </Row>
    );
  };

  return (
    <RowTemplate
      label={label}
      need={need}
      disabled={disabled}
      looks_inactive={looks_inactive}
      content={looks_inactive || disabled ? returnLabelJsx() : returnTextFormJsx()}
    />
  );
};

export default memo(TextArea);
